export default __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo_invoice_dark-aa9caf42c7fda2bad0297e730de93594.png";